import styled from 'styled-components';

import { IconArrowRight } from '@xing-com/icons';
import { mediaConfined } from '@xing-com/layout-tokens';
import * as tokens from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

export const StyledHero = styled(Hero)`
  margin-bottom: ${tokens.spaceM};
`;

export const StyledIconArrowRight = styled(IconArrowRight)``;

export const ButtonWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-top: ${tokens.scale005};

  ${StyledIconArrowRight} {
    margin-right: ${tokens.spaceXXS};
  }

  @media ${mediaConfined} {
    margin-top: ${tokens.scale070};

    ${StyledIconArrowRight} {
      margin-right: ${tokens.spaceM};
    }
  }
`;
